module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1265-min.ae07f6d4.jpg";